import { useEffect, useState } from "react";
import useRoles from "../../hooks/useRoles";
import CreateRoleModal from "./CreateRoleModal";

export default function RolesList({
  selectedRoleId,
  onSelectRole,
  
}) {

  const { roles, loading } = useRoles();
const [showModal, setShowModal] = useState(false);
  useEffect(() => {
    if (roles.length && !selectedRoleId) {
      onSelectRole(roles[0].id);
    }
  }, [roles]);

  return (
    <div className="roles-container">

      <div className="roles-header">
        <h3>Roles</h3>
        <button
  className="create-btn"
  onClick={() => setShowModal(true)}
>
  + Create Role
</button>
      </div>

      {loading && <p>Loading roles...</p>}

      {!loading && roles.length === 0 && (
        <p>No roles found.</p>
      )}

      <div className="roles-list">
        {roles.map(role => (
          <div
            key={role.id}
            className={`role-item ${
              selectedRoleId === role.id ? "active" : ""
            }`}
            onClick={() => onSelectRole(role.id)}
          >
            <div className="role-name">
              {role.role_key}
            </div>

            <div className="role-meta">
              <span className="badge scope">
                {role.scope_type}
              </span>

              <span className="badge level">
                L{role.level}
              </span>

              {role.is_system ? (
                <span className="badge system">
                  SYSTEM
                </span>
              ) : null}
            </div>

          </div>
        ))}
        {showModal && (
  <CreateRoleModal
   
    maxLevel={100} // later calculate dynamically
    onClose={() => setShowModal(false)}
    onCreated={(newRole) => {
      onSelectRole(newRole.id);
      window.location.reload(); // temporary
    }}
  />
)}
      </div>
<style>{`.roles-container {
  display: flex;
  flex-direction: column;
}

.roles-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.create-btn {
  padding: 6px 10px;
  font-size: 13px;
  cursor: pointer;
}

.roles-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.role-item {
  border: 1px solid #ddd;
  padding: 10px;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.2s ease;
}

.role-item:hover {
  background: #f7f7f7;
}

.role-item.active {
  background: #e8f0fe;
  border-color: #1976d2;
}

.role-name {
  font-weight: 600;
  margin-bottom: 4px;
}

.role-meta {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}

.badge {
  font-size: 11px;
  padding: 2px 6px;
  border-radius: 4px;
  background: #eee;
}

.badge.scope {
  background: #dbeafe;
}

.badge.level {
  background: #fde68a;
}

.badge.system {
  background: #fca5a5;
}`}</style>
    </div>
  );
}